<template>
  <div class="coupon df mlr20 mt20 br12" :class="{'ban':gray}" @click="selectCoupon">
    <div class="le df-l-c-ct">
      <span class="f-white f-s">{{coupon['desc_value'+_lang]}}</span>
      <span class="f-white f-xxxs mt10">{{coupon['desc_threshold'+_lang]}}</span>
    </div>
    <!-- 优惠券 -->
    <template v-if="coupon.customerId!==-1">
      <div class="ri f1 p10 df-l-fs">
        <span class="desc f-xs">{{coupon['name'+_lang]}}</span>
        <span class="desc f-xxs" v-if="coupon['desc_orderType'+_lang]">{{coupon['desc_orderType'+_lang]}}</span>
        <span class="desc f-xxxs f-silvery" v-if="coupon['desc_food'+_lang]">{{$t('coupon.applicableFood')}}：{{coupon['desc_food'+_lang]}}</span>
        <span class="desc f-xxxs f-silvery">{{$t('coupon.validityTime')}}：{{coupon['desc_time'+_lang]}}</span>
      </div>
      <div class="seal df-c-ct" v-if="coupon.used||coupon.expired">
        <div class="outcircle circle df-c-ct">
          <div class="incircle circle df-c-ct">
            <div class="_cc f-xs">{{coupon.used?$t('coupon.used'):coupon.expired?$t('coupon.expired'):''}}</div>
          </div>
        </div>
      </div>
    </template>
    <!-- 折扣 -->
    <template v-else-if="coupon.customerId===-1">
      <div class="ri f1 p10 df-l-fs">
        <span class="desc f-xs">{{coupon['name'+_lang]}}</span>
        <span class="desc f-xxs" v-if="coupon['desc_orderType'+_lang]">{{coupon['desc_orderType'+_lang]}}</span>
        <span class="desc f-xxxs f-silvery" v-if="coupon['desc_food'+_lang]">{{$t('coupon.applicableFood')}}：{{coupon['desc_food'+_lang]}}</span>
      </div>
    </template>
    <div class="imgbox checkbox df-c-ct" v-if="!gray">
      <img style="width:24px;height:24px;" :src="coupon.checked?iconCheckok2:iconChecknull2" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Coupon',
  props: {
    coupon: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
    }
  },
  computed: {
    gray() {
      let { customerId, used, expired, canUse } = this.coupon
      if (customerId === -1) {
        return !canUse
      } else {
        return used || expired || !canUse
      }
    },
  },
  methods: {
    selectCoupon() {
      if (this.coupon.customerId === -1) {
        this.coupon.checked = !this.coupon.checked
        this.$emit('select')
      } else if (!this.coupon.used && !this.coupon.expired && this.coupon.canUse) {
        this.coupon.checked = !this.coupon.checked
        this.$emit('select')
      // } else {
        // this.coupon.checked = true
        // this.$emit('select', this.coupon.code)
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.coupon{
  background: #fff;overflow: hidden;position: relative;
  box-shadow: 4px 4px 10px #ccc;
  &::before {
    content: '';display: inline-block;width: 12px;height: 12px;
    background: #f5f5f5;border-radius: 50%;position: absolute;top: 0;bottom: 0;margin: auto;left: calc(-12px / 2);
  }
  &.ban{opacity: .6;}
  .le{
    width: 90px;min-height: 80px;text-align: center;padding: 0 5px;
    background: linear-gradient(141deg, rgba(55, 73, 120, 0.7) 0%, #374978 100%);
  }
  .ri{
    overflow: hidden;
    .desc{min-height: 20px;line-height: 20px;word-break: break-all;margin-left: 2rem;text-indent: -2rem;}
  }
  .seal{
    position: absolute;bottom: -10px;right: -10px;transform: rotateZ(-30deg);
    .outcircle{width: 58px;height: 58px;border: 1px solid #ccc;}
    .incircle{width: 52px;height: 52px;border: 2px solid #ccc;}
  }
  .checkbox{position: absolute;top: 0;bottom: 0;margin: auto;right: 10px;}
}
</style>